import type { ThemeMode } from '../domain/types';
export function readTheme(): ThemeMode {
  try {
    const stored = localStorage.getItem('waschpilot-theme');
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  } catch {
    return 'system';
  }
}
export function applyTheme(theme: ThemeMode) {
  const dark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  try {
    localStorage.setItem('waschpilot-theme', theme);
  } catch {
    /* Device preferences are optional. */
  }
}
